// export const API_URL = "http://127.0.0.1:8000/api";
// export const IMG_URL = "http://127.0.0.1:8000/storage/img/items/";

export const API_URL = "https://api.stockera.dev/api";
export const IMG_URL = "https://api.stockera.dev/storage/img/items/";

export const DEFAULT_IMG_NAME = "default.jpeg";
